import {
  Flex,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { SettingContext } from "../Reducer/SettingProvider";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import AuthContext from "../../Auth/AuthContext";
import { getHostDomain } from "../../../utils/utils";
import AccountInfo from "./Tabs/AccountInfo";
import Personalization from "./Tabs/Personalization";
import Security from "./Tabs/Security";
import { useContext } from "react";

const Profile = () => {
  const baseUrl = getHostDomain();
  const { state: activatedPlan } = useContext(SettingContext) || {};
  const { authUser, logout, getUserData } = useContext(AuthContext) || {};

  const agency = useContext(AgencyContext) || {};
  const { textColor } = agency;

  const tabs = [
    {
      id: 1,
      label: "Account Information",
      children: (
        <AccountInfo
        baseUrl={baseUrl}
          agency={agency}
          authUser={authUser}
          activatedPlan={activatedPlan}
          getUserData={getUserData}
        />
      ),
    },
    // {
    //   label: "Personalization & Preferences",
    //   children: <Personalization agency={agency} authUser={authUser} />,
    // },
    {
      id: 2,
      label: "Security & Access",
      children: <Security agency={agency} baseUrl={baseUrl} logout={logout} />,
    },
  ];

  return (
    <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
      <Flex gap={2} w={"100%"} alignItems="center" py={2}>
        <Heading color={textColor} fontSize="xl">
          Profile Settings
        </Heading>
      </Flex>
      <Tabs>
        <TabList>
          {tabs.map((tab) => (
            <Tab key={tab.id} color={textColor}>
              {tab.label}
            </Tab>
          ))}
        </TabList>

        <TabPanels>
          {tabs.map((tab) => (
            <TabPanel>{tab.children}</TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Flex>
  );
};

export default Profile;
